export const transformArrayToObjectById = (arr = []) =>
	arr.reduce((acc, item) => ({ ...acc, [item?.id]: item }), {})
